/**
 * @generated SignedSource<<d2c9b3ae48db09b1a284216dfecf5ba7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetTxnsNeedsReviewInputObject = {
  needsReview: boolean;
  txnIds: ReadonlyArray<string>;
};
export type transactionsPage_SetTxnsNeedsReviewMutation$variables = {
  input: SetTxnsNeedsReviewInputObject;
};
export type transactionsPage_SetTxnsNeedsReviewMutation$data = {
  readonly setTxnsNeedsReview: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type transactionsPage_SetTxnsNeedsReviewMutation = {
  response: transactionsPage_SetTxnsNeedsReviewMutation$data;
  variables: transactionsPage_SetTxnsNeedsReviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "transactionsPage_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "transactionsPage_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c0d57f08f6bef61c6594c067f2a0dac",
    "id": null,
    "metadata": {},
    "name": "transactionsPage_SetTxnsNeedsReviewMutation",
    "operationKind": "mutation",
    "text": "mutation transactionsPage_SetTxnsNeedsReviewMutation(\n  $input: SetTxnsNeedsReviewInputObject!\n) {\n  setTxnsNeedsReview(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "350ff49eb6bc3c7675174d8cd5699d30";

export default node;
